import { connect } from 'react-redux';

import CssClassesTagsInput from './css_classes_tagsinput.jsx';

import { getStylePresets } from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state)=> {
  const stylePresets = getStylePresets(state);

  return { stylePresets };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CssClassesTagsInput);
